import data from '@/data';
import Vue from 'vue';

export default ({
  namespaced: true,
  state: {
    fromDate: Date(),
    toDate: Date(),
    teamFilter: null,
    forRegion: null,
    groupBy: 'PROJECT',
    lookup: {
      employees: {},
      teams: {},
      clients: {},
      circles: {},
      allocations: {},
      milestones: {},
      overallocations: {
        byEmployee: {},
        byCircle: {},
        byEmployeeCircle: {},
      },
      forecasts: {
        byEmployee: {},
        byProject: {},
        byEmployeeProject: {},
      },
      groups: {},
      regions: {}
    },
    teams: [],
    employees: [],
    clients: [],
    circles: [],
    allocations: [],
    milestones: [],
    groups: [],
    regions:[],
    forecastType: 'FUTURE_PLANNED',
    colors: [
      'orange',
      'green',
      'aqua',
      'blue',
      'purple',
      'magenta',
      'red',
      'gray',
      'black',
    ],
    colorsHex: [
      '#fa6400',
      '#1e8c0a',
      '#3ca0c8',
      '#004696',
      '#78328c',
      '#d22864',
      '#d20a0a',
      '#888',
      '#222',
    ],
  },
  mutations: {
    initialized(state, { teamFilter, groupBy, fromDate, toDate, clients, employees, circles, allocations, milestones, groups, regions }) {

      // If group by has changed - reset forecast type
      if(state.groupBy !== groupBy) {
        // eslint-disable-next-line
        state.forecastType = 'FUTURE_PLANNED';
      }

      // eslint-disable-next-line
      state.teamFilter = teamFilter;

      // eslint-disable-next-line
      state.groupBy = groupBy;

      // eslint-disable-next-line
      state.fromDate = fromDate;

      // eslint-disable-next-line
      state.toDate = toDate;

      // eslint-disable-next-line
      state.clients = clients;
      // eslint-disable-next-line
      state.lookup.clients = clients?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      // eslint-disable-next-line
      state.lookup.employees = employees?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      // eslint-disable-next-line
      state.employees = employees;
      // eslint-disable-next-line
      state.lookup.teams = employees?.reduce((map, obj) => {
        if(obj.teamId && !map[obj.teamId]) {
          map[obj.teamId] = { id: obj.teamId, name: obj.teamName };
        }
        return map;
      }, {});
      // eslint-disable-next-line
      state.teams = Object.values(state.lookup.teams);
      
      // eslint-disable-next-line
      state.allocations = allocations;
      state.lookup.allocations = allocations?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      // eslint-disable-next-line
      state.milestones = milestones;
      state.lookup.milestones = milestones?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      
      // eslint-disable-next-line
      state.groups = groups;
      state.lookup.groups = groups?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});

      // eslint-disable-next-line
      state.regions = regions;
      state.lookup.regions = regions?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});

      // eslint-disable-next-line
      state.circles = circles;
      state.lookup.circles = circles?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      // Add default absence project
      if (state.circles.findIndex(q => q.id === null) === -1) {
        state.circles.unshift({
          id: null,
          title: 'Ferie/Fri',
          code: '',
          colorCode: 'black'
        });
      }
    },
    periodChanged(state, { fromDate, toDate, teamFilter, forRegion, circles, allocations, milestones, employees }) {
      // eslint-disable-next-line
      state.fromDate = fromDate;

      // eslint-disable-next-line
      state.toDate = toDate;

      state.teamFilter = teamFilter;

      state.forRegion = forRegion;
      
      // // eslint-disable-next-line
      // state.lookup.employees = employees?.reduce((map, obj) => {
      //   map[obj.id] = obj;
      //   return map;
      // }, {});
      // // eslint-disable-next-line
      // state.employees = employees;

      // // eslint-disable-next-line
      // state.circles = circles;
      // state.lookup.circles = circles?.reduce((map, obj) => {
      //   map[obj.id] = obj;
      //   return map;
      // }, {});

      // // Add default absence project
      // if (state.circles.findIndex(q => q.id === null) === -1) {
      //   state.circles.unshift({
      //     id: null,
      //     title: 'Ferie/Fri',
      //     code: '',
      //     colorCode: 'black'
      //   });
      // }

      // eslint-disable-next-line
      state.allocations = allocations;
      state.lookup.allocations = allocations?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});

      // eslint-disable-next-line
      state.lookup.employees = employees?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
      // eslint-disable-next-line
      state.employees = employees;
      // eslint-disable-next-line
      state.lookup.teams = employees?.reduce((map, obj) => {
        if(obj.teamId && !map[obj.teamId]) {
          map[obj.teamId] = { id: obj.teamId, name: obj.teamName };
        }
        return map;
      }, {});
      // eslint-disable-next-line
      state.teams = Object.values(state.lookup.teams);
    },
    allocationAdded(state, { allocation }) {
      state.allocations.push(allocation);
      state.lookup.allocations = state.allocations?.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    allocationDeleted(state, { allocationId }) {
      var allocationToLookup = state.lookup.allocations[allocationId];
      state.allocations.splice(state.allocations.indexOf(allocationToLookup), 1);
      state.lookup.allocations = state.allocations.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    allocationUpdated(state, { allocation }) {
      var allocationToUpdate = state.lookup.allocations[allocation.id];

      Object.assign(allocationToUpdate, allocation);
      state.lookup.allocations = state.allocations.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    allocationsAddOrUpdate(state, {allocations}) {
      if (Array.isArray(allocations)) {
        allocations.forEach(allocation => {
          if (Object.prototype.hasOwnProperty.call(state.lookup.allocations, allocation.id)) {
            // update existing allocation in state.allocations
            const existing = state.allocations.find(q => q.id === allocation.id);
            if (existing) {
              Object.assign(existing, allocation);
            }
          }
          else {
            // add new allocation to state.allocations
            state.allocations.push(allocation);
          }
          // update or add allocation to state.lookup.allocations
          Vue.set(state.lookup.allocations, allocation.id, allocation);
        });
      }
    },
    // Remove allocations with the specified allocationId as their parentAllocationId
    // The allocations are only removed from the frontend state.
    removeChildAllocations(state, {allocationId}) {
      state.allocations = state.allocations.filter(q => q.parentAllocationId !== allocationId);
      Object.values(state.lookup.allocations).forEach(lookupAllocation => {
        if (lookupAllocation.parentAllocationId === allocationId) {
          Vue.delete(state.lookup.allocations, lookupAllocation.id);
        }
      })
    },
    milestoneAdded(state, { milestone }) {
      state.milestones.push(milestone);
      state.lookup.milestones = state.milestones.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    milestoneDeleted(state, { milestoneId }) {
      var milestoneToLookup = state.lookup.milestones[milestoneId];
      state.milestones.splice(state.milestones.indexOf(milestoneToLookup), 1);
      state.lookup.milestones = state.milestones.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    milestoneUpdated(state, { milestone }) {
      var milestoneToUpdate = state.lookup.milestones[milestone.id];

      Object.assign(milestoneToUpdate, milestone);
      state.lookup.milestones = state.milestones.reduce((map, obj) => {
        map[obj.id] = obj;
        return map;
      }, {});
    },
    overallocationUpdated(state, { overallocations }) {
      // eslint-disable-next-line
      state.lookup.overallocations.byEmployeeCircle = overallocations?.reduce((map, obj) => {
        if(!map[`${obj.employeeId}-${obj.circleId}`])
          map[`${obj.employeeId}-${obj.circleId}`] = [];

        map[`${obj.employeeId}-${obj.circleId}`].push(obj);
        return map;
      }, {}) ?? {};

      // eslint-disable-next-line
      state.lookup.overallocations.byEmployee = overallocations?.reduce((map, obj) => {
        if(!map[obj.employeeId])
          map[obj.employeeId] = [];

        map[obj.employeeId].push(obj);
        return map;
      }, {}) ?? {};

      // eslint-disable-next-line
      state.lookup.overallocations.byCircle = overallocations?.reduce((map, obj) => {
        if(!map[obj.circleId])
          map[obj.circleId] = [];

        map[obj.circleId].push(obj);
        return map;
      }, {}) ?? {};
    },
    forecastUpdated(state, { forecasts, forecastKey }) {
      // eslint-disable-next-line
      state.forecastType = forecastKey;

      // eslint-disable-next-line
      state.lookup.forecasts.byEmployeeProject = forecasts?.reduce((map, obj) => {
        if(!map[`${obj.employeeId}-${obj.circleId}`])
          map[`${obj.employeeId}-${obj.circleId}`] = [];

        map[`${obj.employeeId}-${obj.circleId}`].push(obj);
        return map;
      }, {});

      // eslint-disable-next-line
      state.lookup.forecasts.byEmployee = forecasts?.reduce((map, obj) => {
        if(!map[obj.employeeId])
          map[obj.employeeId] = [];

        map[obj.employeeId].push(obj);
        return map;
      }, {});

      // eslint-disable-next-line
      state.lookup.forecasts.byProject = forecasts?.reduce((map, obj) => {
        if(!map[obj.circleId])
          map[obj.circleId] = [];

        map[obj.circleId].push(obj);
        return map;
      }, {});
    },
  },
  actions: {
    initialize({ commit, state, dispatch }, { teamFilter, groupBy, fromDate, toDate, forRegion }) {
      
      // Fetch metadata
      return Promise.all([
        //data.clients.getActive(),
        data.employees.getActiveInPeriod(fromDate, toDate),
        data.circlesRepository.getForPeriod(fromDate, toDate, null),
        data.allocations.getForPeriod(fromDate, toDate, teamFilter, forRegion),
        data.groups.getForPeriod(fromDate, toDate, null)
      ])
      .then((response) => {
        commit('initialized', {
          teamFilter: teamFilter,
          groupBy: groupBy,
          fromDate: fromDate,
          toDate: toDate,
          forRegion: forRegion,
          clients: null, //response[0].data,
          employees: response[0],
          circles: response[1],
          allocations: response[2],
          groups: response[3],
          regions: [{id: 'syd', name: 'syd'}, {id: 'nord', name: 'nord'}]
        });
        dispatch('updateOverallocations');
        dispatch('updateForecasts', { forecastKey: state.forecastType });
      })
      .catch((error) => {
        console.log(error);
      });
    },
    changePeriod({ commit, state, dispatch }, { fromDate, toDate, teamFilter, forRegion }) {
      // Fetch metadata
      return Promise.all([
        data.allocations.getForPeriod(fromDate, toDate, teamFilter, forRegion),
        data.employees.getActiveInPeriod(fromDate, toDate)
      ])
      .then((response) => {
        commit('periodChanged', {
          fromDate: fromDate,
          toDate: toDate,
          teamFilter: teamFilter,
          forRegion: forRegion,
          allocations: response[0]/*.data*/,
          employees: response[1]
        });
        this.fetchEmployees(fromDate, toDate);
        dispatch('updateOverallocations');
        dispatch('updateForecasts', { forecastKey: state.forecastType });
      })
      .catch((error) => {
        console.log(error);
      });
    },
    // fetchEmployees({commit, state}, fromDate, toDate){
    //   console.log('im hit')
    //   data.employees.getActiveInPeriod(fromDate, toDate).then(response => {

    //     commit('initialized', {
    //       teamFilter: state.teamFilter,
    //       groupBy: state.groupBy,
    //       fromDate: fromDate,
    //       toDate: toDate,
    //       forRegion: state.forRegion,
    //       clients: null, //response[0].data,
    //       employees: response,
    //       circles: state.circles,
    //       allocations: state.allocations,
    //       groups: state.groups,
    //       regions: state.regions})
    //   }
    //   );
    // },
    addAllocation({ commit, state, dispatch }, dto) {

        return data.allocations
          .create(dto.allocationType, dto.circleId, dto.employeeId, dto.startDate, dto.allocationSpanInDays, dto.groupId)
          .then((response) => {
            commit('allocationAdded', {
              allocation: response.data
            });
            dispatch('updateOverallocations');
            dispatch('updateForecasts', { forecastKey: state.forecastType });
          })
          .catch((error) => {
            console.log(error);
          });
    },
    updateAllocation({ commit, state, dispatch }, { allocation }) {
      const retrieveChildren = !!(allocation.attachNewAllocation);
      const existingAllocation = state.allocations.find(q => q.id === allocation.id);
      const removeChildren = existingAllocation.replacementId !== null && allocation.replacementId === null;
      return data.allocations
        .update(allocation)
        .then((response) => {
          commit('allocationUpdated', {
            allocation: response.data
          });
          if (removeChildren) {
            data.allocations
              .getForParent(allocation.id)
              .then((response) => {
                if (Array.isArray(response.data)) {
                  for (let childAllocation of response.data) {
                    dispatch('deleteAllocation', {
                      allocationId: childAllocation.id,
                      updateTag: childAllocation._UpdateTag
                    });
                  }
                }
              })
              .catch((error) => console.error(error));
          }
          if (retrieveChildren) {
            dispatch('updateChildAllocations', allocation.id);
          }
          dispatch('updateOverallocations');
          dispatch('updateForecasts', { forecastKey: state.forecastType });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteAllocation({ commit, state, dispatch }, { allocationId, updateTag }) {
      return data.allocations
        .delete(allocationId, updateTag)
        .then(() => {
          commit('allocationDeleted', {
            allocationId: allocationId
          });
          dispatch('updateOverallocations');
          dispatch('updateForecasts', { forecastKey: state.forecastType });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Insert or update children of the specified allocation, into the allocations lookup
    updateChildAllocations({commit, state, dispatch}, allocationId) {
      
      return data.allocations
        .getForParent(allocationId)
        .then((response) => {
          if (Array.isArray(response.data)) {
            commit('removeChildAllocations', { allocationId });
            commit('allocationsAddOrUpdate', { allocations: response.data });
          }
          dispatch('updateOverallocations');
          dispatch('updateForecasts', { forecastKey: state.forecastType });
        })
        .catch((error) => {
          console.log(error);
        })
    },
    addMilestone({ commit }, {
      name,
      circleId,
      milestoneType,
      date,
      percentageCompleted }) {
        return data.milestones
          .create(name, milestoneType, circleId, date, percentageCompleted)
          .then((response) => {
            commit('milestoneAdded', {
              milestone: response.data
            });
          })
          .catch((error) => {
            console.log(error);
          });
    },
    updateMilestone({ commit }, { milestone }) {
        return data.milestones
          .update(milestone)
          .then((response) => {
            commit('milestoneUpdated', {
              milestone: response.data
            });
          })
          .catch((error) => {
            console.log(error);
          });
    },
    deleteMilestone({ commit }, { milestoneId, updateTag }) {
      return data.milestones
        .delete(milestoneId, updateTag)
        .then(() => {
          commit('milestoneDeleted', {
            milestoneId: milestoneId
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateOverallocations({ commit, state }) {
      return data.overallocations
        .getForPeriod(state.fromDate, state.toDate, state.teamFilter)      
        .then((response) => {
          commit('overallocationUpdated', {
            overallocations: response.data //.data
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateForecasts({ commit, state }, { forecastKey }) {
      return data.forecasts
        .getFromDate(forecastKey, state.fromDate, null)
        .then((response) => {
          commit('forecastUpdated', {
            forecasts: response,
            forecastKey: forecastKey,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  getters: {
    teamFilter(state) { return state.teamFilter; },
    groupBy(state) { return state.groupBy; },
    forecastType(state) { return state.forecastType; },
    teams(state) { return state.teams; },
    employees(state) { return state.employees; },
    employeeLookup(state) { return state.lookup.employees; },
    clients(state) { return state.clients; },
    clientLookup(state) { return state.lookup.clients; },
    circleLookup(state) { return state.lookup.circles; },
    circles(state) { return state.circles; },
    allocations(state) { return state.allocations; },
    milestones(state) { return state.milestones; },
    overallocations(state) { return state.lookup.overallocations; },
    forecasts(state) { return state.lookup.forecasts; },  
    colors(state) { return state.colors; },
    colorsHex(state) { return state.colorsHex; },
    groups(state) { return state.groups; },
    regions(state) { return state.regions; },
  },
});
